import { CSSProperties, ReactElement, useCallback } from "react";
import { GroupedTableHeaderCell } from "../GroupedTableHeaderCell";
import { GroupedTableHeaderProps } from "./GroupedTableHeader.types";
import { GroupedTableColumn } from "../types";

/**
 * GroupedTableHeader component
 *
 * @param {GroupedTableHeaderProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function GroupedTableHeader<TItemType>({
    columns,
    sort,
}: GroupedTableHeaderProps<TItemType>): ReactElement | null {
    const renderColumn = useCallback((column: GroupedTableColumn<TItemType>, index: number) => {
        const style: CSSProperties = {};
        
        if (column.width) {
            style.width = isNaN(+column.width)
                ? column.width
                : `${column.width}px`;
            style.flexBasis = style.width;
        }
        
        return (
            <div className="GroupedTableHeader-Column"
                 key={index}
                 style={style}>
                <GroupedTableHeaderCell<TItemType>
                    column={column}
                    renderToolbar={index === 0}
                    sort={sort} />
            </div>
        );
    }, [sort]);

    return (
        <div className="GroupedTableHeader">
            {columns.map(renderColumn)}
        </div>
    );
}

export default GroupedTableHeader;

